import { render, staticRenderFns } from "./ConsentToggleButton.vue?vue&type=template&id=bae3b8a4&scoped=true"
import script from "./ConsentToggleButton.vue?vue&type=script&lang=ts"
export * from "./ConsentToggleButton.vue?vue&type=script&lang=ts"
import style0 from "./ConsentToggleButton.vue?vue&type=style&index=0&id=bae3b8a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae3b8a4",
  null
  
)

export default component.exports